export const PLAN_SETTINGS = {
  BUSINESS_STARTER_ID: 'prod_RTCHcfPvc2mfub',
  BUSINESS_ESSENTIALS_ID: 'prod_RTCXM70bHmSmbQ',
  BUSINESS_GROWTH_ID: 'prod_RTCeHLMNuQlsUQ',
};
